<template>
  <div>
    <a-form-item :label="$t('cloudenv.text_524')" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-select v-decorator="decorators.server_duration" mode="multiple" @change="changeReviewOptions">
        <a-select-option v-for="item in options" :key="item" :value="item">
          {{ getLabel(item) }}
        </a-select-option>
      </a-select>
      <a-form-model v-if="isAddShow" ref="form1" :model="form1" :rules="rules" class="custom-item d-flex align-items-center">
        <a-form-model-item prop="value">
          <a-input-number v-model="form1.value" style="width: 100px" :min="1" :max="999" :precision="0" :step="1" />
        </a-form-model-item>
        <a-form-model-item prop="unit">
          <a-select v-model="form1.unit" class="ml-2" style="width: 100px">
            <a-select-option v-for="item in units" :key="item.key" :value="item.key">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="link" class="ml-2" @click="addCustomItem">
            {{ $t('common_114')}}
          </a-button>
          <a-button type="link" class="ml-2" @click="()=>isAddShow=false">
            {{ $t('common_115')}}
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <div v-else>
        <a-form-model-item>
          <a-button type="link" @click="()=>isAddShow=true">
            {{ $t('common.add_custom_item')}}
          </a-button>
        </a-form-model-item>
      </div>
    </a-form-item>
    <a-form-item :label="$t('common.text00100')" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-radio-group v-model="form1.type">
        <a-radio-button v-for="item in reviewOptions" :key="item" :value="item">
          {{ getLabel(item) }}
        </a-radio-button>
      </a-radio-group>
    </a-form-item>
  </div>
</template>

<script>
import { validateModelForm } from '@/utils/validate'
import { getDurationLabel } from '@/utils/utils'

export default {
  name: 'ServerDuration',
  inject: ['form'],
  props: {
    labelCol: {
      type: Object,
      default: () => {
        return {
          span: 3,
        }
      },
    },
    wrapperCol: {
      type: Object,
      default: () => {
        return {
          span: 21,
        }
      },
    },
    presentPolicies: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    const { server_duration = [] } = this.presentPolicies
    let options = ['none', '1h', '6h', '1d', '3d', '1w', '1m', 'custom']
    server_duration.forEach(item => {
      if (!options.includes(item)) {
        options.push(item)
      }
    })
    options = this.sortOptions(options)
    return {
      decorators: {
        server_duration: [
          'server_duration',
          {
            initialValue: server_duration.length > 0 ? this.sortOptions(server_duration) : ['none', '1h', '6h', '1d', '3d', '1w', '1m', 'custom'],
            rules: [
              { required: true, message: this.$t('common.tips.select', [this.$t('system.category.server_duration')]) },
            ],
          },
        ],
      },
      units: [
        {
          key: 'h',
          label: this.$t('common_time.hour'),
        },
        {
          key: 'd',
          label: this.$t('common_time.day'),
        },
        {
          key: 'w',
          label: this.$t('common_time.week'),
        },
        {
          key: 'm',
          label: this.$t('common_time.month'),
        },
        {
          key: 'y',
          label: this.$t('common_time.year'),
        },
      ],
      options,
      isAddShow: false,
      form1: {
        value: 1,
        unit: 'h',
        type: 'none',
      },
      rules: {
        value: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const t = `${value}${this.form1.unit}`
              if (this.options.some(item => item === t)) {
                callback(new Error(this.$t('common.existing_custom_duration')))
              }
              if (!value) {
                callback(new Error(this.$t('common.tips.input', [this.$t('common.custom_duration')])))
              }
              callback()
            },
          },
        ],
        unit: [
          { required: true, message: this.$t('common.tips.select', [this.$t('common.custom_duration')]) },
        ],
      },
      reviewOptions: options,
    }
  },
  methods: {
    getLabel (item) {
      return getDurationLabel(item)
    },
    async addCustomItem () {
      try {
        await validateModelForm(this.$refs.form1)
        const { value, unit } = this.form1
        const duration = value + unit
        this.options = [...this.options, duration]
        this.form.fc.setFieldsValue({
          server_duration: [...this.form.fc.getFieldValue('server_duration'), duration],
        })
        this.isAddShow = false
        this.form1 = {
          value: 1,
          unit: 'h',
        }
      } catch (error) {
        throw error
      }
    },
    sortOptions (options) {
      console.log(options)
      const opts = [...options]
      opts.sort((a, b) => {
        // 定义排序优先级
        const getPriority = (key) => {
          if (key === 'none') return 0
          if (key === 'custom') return 999
          if (key.endsWith('h')) return 1
          if (key.endsWith('d')) return 2
          if (key.endsWith('w')) return 3
          if (key.endsWith('m')) return 4
          if (key.endsWith('y')) return 5
          return 6
        }
        const priorityA = getPriority(a)
        const priorityB = getPriority(b)
        // 如果优先级不同，按优先级排序
        if (priorityA !== priorityB) {
          return priorityA - priorityB
        }
        // 如果优先级相同，按数字大小排序
        const numA = parseInt(a) || 0
        const numB = parseInt(b) || 0
        return numA - numB
      })
      console.log(opts)
      return opts
    },
    changeReviewOptions () {
      const values = this.form.fc.getFieldValue('server_duration')
      if (!values.includes(this.form1.type)) {
        this.form1.type = this.form.fc.getFieldValue('server_duration')[0]
      }
      this.reviewOptions = this.sortOptions(this.form.fc.getFieldValue('server_duration'))
    },
  },
}
</script>
